// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".st1[data-v-4eaff3f2] {\n  fill: #eee;\n}\n.st2[data-v-4eaff3f2] {\n  fill: #0d93c5;\n}\n.st3[data-v-4eaff3f2] {\n  fill: none;\n}\n.st6[data-v-4eaff3f2] {\n  fill: #fff;\n}\n.st7[data-v-4eaff3f2] {\n  fill: #a1e7fc;\n}\n.st8[data-v-4eaff3f2] {\n  fill: #23286b;\n}\n.st16[data-v-4eaff3f2] {\n  fill: #d6d7d8;\n}\n.st31[data-v-4eaff3f2] {\n  fill: #ffbeb6;\n}\n", ""]);
// Exports
module.exports = exports;
